<template>
  <el-row :gutter="30">
    <el-col style="margin-bottom: 20px;" :span="12" v-for="(chart, index) in charts" :key="index">
      <div>
        <span class="sub-title">{{ formatterForRscName(chart.rscInfo) }}</span>
        <span v-if="isTrue(chart.rscInfo.isAbnormal)" class="abnormal-message">
          {{ chart.rscInfo.abnormalMessage }}
        </span>
      </div>
      <highcharts :options="chart.options" v-show="!exportingPdfForIe" :class="`export-pdf-line-chart-${selectedObjId}-${index}`" />
      <img v-show="exportingPdfForIe" :class="`export-pdf-line-chart-${selectedObjId}-${index}`" />
    </el-col>
  </el-row>
</template>

<script>
import { isNil, isEmpty, forEach, cloneDeep } from 'lodash';
import { lineOptions } from '@/constants/chart-options';
import { isTrue } from '@/utils/boolean';

const chartOptions = cloneDeep(lineOptions);
chartOptions.chart.height = 100;
chartOptions.xAxis.labels.format = '{value: %H:%M}';
export default {
  name: 'WPerformanceHistory',
  props: {
    eventHistData: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Array,
      default: () => [],
    },
    /**
     * (IE) PDF출력 시 highchart > img로 변경을 위한 클래스명 지정을 위한 키
     * @type {Object}
     */
    selectedObjId: {
      type: Number,
      default: () => 0,
    },
    exportingPdfForIe: {
      type: Boolean,
    },
  },
  computed: {
    charts() {
      const charts = [];
      const eventDatetime = isEmpty(this.eventHistData) ? null : this.eventHistData.checkDatetime;
      if (!isEmpty(this.data)) {
        forEach(this.data, (item) => {
          const chart = {
            rscInfo: item,
            options: cloneDeep(chartOptions),
          };
          chart.options.series = [item.chartData];
          if (eventDatetime !== null) {
            chart.options.xAxis.plotLines = [
              {
                width: 1,
                value: eventDatetime,
                dashStyle: 'shortdash',
                color: '#ffa7a7',
              },
            ];
          }
          charts.push(chart);
        });
      }
      return charts;
    },
  },
  methods: {
    isTrue,
    formatterForRscName(data) {
      return !isNil(data.rscKeyName) && data.rscKey !== '_' ? `${data.rscName} (${data.rscKeyName})` : data.rscName;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/popup/FaultAnalysisPopup/components/FaultAnalysisInfoView/PerformanceHistory.vue